import { Value } from '@philips-internal/oswald-ui-core';

interface GeneratePurchaseRequestIntegration {
  purchaseRequestNumber: number,
  typeInterfaceIntegration: string,
  typeOfIntegration: string,
}

interface PurchaseRequestResponse {
  requestSentWithSuccess: boolean
}

interface FormData extends GeneratePurchaseRequestIntegration, Record<string, Value> {}

const normalizeGeneratePurchaseRequestIntegrationBody = (purchaseRequestNumber: number, typeInterfaceIntegration: string, typeOfIntegration: string): FormData => ({
  purchaseRequestNumber,
  typeInterfaceIntegration,
  typeOfIntegration,
});
  
export {
  normalizeGeneratePurchaseRequestIntegrationBody,
  PurchaseRequestResponse,
};
